export default (actionName) => ({
  REQUEST: `${actionName}_REQUEST`,
  SUCCESS: `${actionName}_SUCCESS`,
  ERROR: `${actionName}_ERROR`,
  STATUS: `${actionName}_STATUS`,
  BEGIN: `${actionName}_BEGIN`,
  END: `${actionName}_END`,
  EVENTS: `${actionName}_EVENTS`,
})
